import { useMsal } from '@azure/msal-react';
import React from 'react';
import { Role } from '../utils';

export interface IPermissionContext {
    isPermitted: (feature: Feature) => boolean,
    isRole: (role: string) => boolean,
    roleName: string,
    userName: string,
    userId: string
}

export enum Feature {
    Contract,
    ContractVariation,
    ContractVariation_Create,
    Enquiry,
    StorageRequest,
    DispatchRequest,
    DispatchRequest_CommercialAgreement,
    DispatchRequest_Picklist,
    DispatchRequest_DispatchNote,
    Audit,
    Inventory_UpdateMaterial,
    Dispatch_ContractSpares,
    Reports
}

export const PermissionContext = React.createContext<IPermissionContext>({
    isPermitted: () => { return false; },
    isRole: () => { return false; },
    roleName: "",
    userName: "",
    userId: "",
});

export const PermissionContextProvider: React.FC = ({
    ...props
}) => {

    const { accounts } = useMsal();
    // const userId = accounts ? accounts[0].localAccountId : "";

    const getRole = () => {

        let claims = accounts[0].idTokenClaims as any;
        let roles = claims.roles as string[];
        return roles[0];
    };

    const getUsername = () => {

        return accounts[0].username;
    }

    const getUserId = () => {

        return accounts[0].localAccountId;
    }

    const isPermitted = (feature: Feature) => {

        //-- Debugging Permissions --//
        //return false;
        //return true;

        let role = getRole();
        let allowedRoles = [];

        switch (feature) {

            case Feature.StorageRequest:
                allowedRoles = [
                    Role.External,
                    Role.Internal.Admin,
                    Role.Internal.AssetProtection,
                    Role.Internal.Procurement,
                    Role.Internal.Standard,
                    Role.Internal.Admin,
                    Role.Internal.Commercial];
                return allowedRoles.includes(role);
            case Feature.ContractVariation:
            case Feature.Contract:
                allowedRoles = [
                    Role.Internal.Admin,
                    Role.Internal.AssetProtection,
                    Role.Internal.Procurement];
                return allowedRoles.includes(role);
            case Feature.ContractVariation_Create:
                allowedRoles = [
                    Role.Internal.Admin,
                    Role.Internal.AssetProtection,
                    Role.Internal.Procurement];
                return allowedRoles.includes(role);
            case Feature.DispatchRequest:
                allowedRoles = [
                    Role.External,
                    Role.Internal.AssetProtection,
                    Role.Internal.Procurement,
                    Role.Internal.Standard,
                    Role.Internal.Admin,
                    Role.Internal.Commercial
                ];
                return allowedRoles.includes(role);
            case Feature.DispatchRequest_CommercialAgreement:
                allowedRoles = Object.values(Role.Internal);
                return allowedRoles.includes(role);
            case Feature.DispatchRequest_Picklist:
                allowedRoles = [
                    Role.Internal.AssetProtection,
                    Role.Internal.Admin,
                    Role.Internal.Commercial
                ];
                return allowedRoles.includes(role);
            case Feature.DispatchRequest_DispatchNote:
                allowedRoles = [
                    Role.Internal.AssetProtection,
                    Role.Internal.Admin,
                    Role.Internal.Commercial
                ];
                return allowedRoles.includes(role);
            case Feature.Audit:
                allowedRoles = [
                    Role.Internal.Admin,
                    Role.Internal.AssetProtection,
                    Role.Internal.Procurement
                ];
                return allowedRoles.includes(role);
            case Feature.Inventory_UpdateMaterial:
                allowedRoles = [
                    Role.Internal.AssetProtection,
                    Role.Internal.Admin,
                ];
                return allowedRoles.includes(role);
            case Feature.Dispatch_ContractSpares:
                allowedRoles = [
                    Role.Internal.AssetProtection,
                    Role.Internal.Procurement,
                    Role.Internal.Admin,
                ];
                return allowedRoles.includes(role);
            case Feature.Reports:
                allowedRoles = [
                    Role.Internal.AssetProtection,
                    Role.Internal.Admin
                ];
                return allowedRoles.includes(role);
            default: return false;
        }

    }

    const isRole = (role: string) => {
        return getRole().toUpperCase() === role.toUpperCase();

    }

    return <PermissionContext.Provider value={{
        isRole,
        isPermitted,
        roleName: getRole(),
        userName: getUsername(),
        userId: getUserId()
    }} >
        {props.children}
    </PermissionContext.Provider >

}
